import $ from "jquery";
window.$ = window.jQuery = $;
window.app.factory("processIndicator", [
  "$q",
  function($q) {
    const processes = {};
    const $ = sel => {
      return angular.element(
        typeof sel === "string" ? document.querySelector(sel) : sel
      );
    };

    function start(id, buttonOrSelector, grayoutSelector) {
      if (processes[id]) {
        stop(id);
      }
      processes[id] = { buttonOrSelector, grayoutSelector };
      if (buttonOrSelector) {
        const $icon = getIcon(buttonOrSelector);
        processes[id].originalIcon = $icon.html();
        $icon.html("rotate_right");
        $icon.addClass("spinning");
      }
      if (grayoutSelector) {
        $(grayoutSelector).addClass("disabled-element");
      }
    }

    function stop(id) {
      if (!processes[id]) return;
      const { buttonOrSelector, grayoutSelector, originalIcon } = processes[id];
      if (buttonOrSelector) {
        const $icon = getIcon(buttonOrSelector);
        $icon.html(originalIcon);
        $icon.removeClass("spinning");
      }
      if (grayoutSelector) {
        $(grayoutSelector).removeClass("disabled-element");
      }
    }

    function track(buttonOrSelector, grayoutSelector, func, id) {
      id = id || "_pind_" + Math.floor(Math.random() * 999999);
      return (...args) => {
        start(id, buttonOrSelector, grayoutSelector);
        $q.resolve(func(...args)).finally(() => stop(id));
      };
    }

    function getIcon(buttonOrSelector) {
      const $el = window.$(buttonOrSelector).first();
      if ($el.is(".material-icons")) {
        return $el;
      } else {
        return $el.find(".material-icons");
      }
    }

    return { start, stop, track };
  }
]);



// WEBPACK FOOTER //
// ./src/services/processIndicator.js